import { StyleSheet, Dimensions, Platform } from 'react-native'

import { Colors, Metrics } from '@vfgroup-oneplatform/foundation/Components/Themes';

const screenWidth = Dimensions.get('window').width;

const elevationStyle = {
  elevation: 2,
  shadowColor: 'rgba(0, 0, 0, 0.16)',
  shadowOffset: {
    width: 0,
    height: 2,
  },
  shadowRadius: 4,
  shadowOpacity: 1,
};

const heightToWidthRatio = 0.479;

const mainCardWidth = screenWidth - Metrics.mainContentPadding * 2;

let divideHeight = 1
if (screenWidth > 800) {
  divideHeight = 2.5
}


export default StyleSheet.create({
  main: {
    width: mainCardWidth,
    height: mainCardWidth * heightToWidthRatio / divideHeight,
    borderRadius: 6,
    backgroundColor: Colors.cardBackground,
    ...elevationStyle,
  },
  sec: {
    width: mainCardWidth * heightToWidthRatio,
    height: mainCardWidth * heightToWidthRatio / divideHeight,
    borderRadius: 6,
    backgroundColor: Colors.cardBackground,
    ...elevationStyle,
  },
  addMore: {
    width: mainCardWidth * heightToWidthRatio,
    height: mainCardWidth * heightToWidthRatio * 0.45 / divideHeight,
    borderRadius: 6,
    backgroundColor: Colors.cardBackground,
    ...elevationStyle,
  },
  withAddButton: {
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderStyle: 'dashed',
  },
  gallery: {
    width: Metrics.galleryCardWidth,
    height: 182,
    marginRight: Metrics.galleryCardMargin,
    backgroundColor: Colors.transparent,
  },
  discover: {
    width: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : screenWidth - Metrics.mainContentPadding * 2,
    flex: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 1 : null,
    marginBottom: 66,
    borderRadius: 10,
    ...elevationStyle,
    marginTop: -13,
  },
  discover_fixed_component: {
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : 32,
    width: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : mainCardWidth,
    flex: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 1 : null,
    height: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? null : mainCardWidth / divideHeight,
    borderRadius: 10,
    ...elevationStyle,
  },
  discover_custom: {
    marginBottom: 32,
    width: mainCardWidth,
    borderRadius: 10,
    ...elevationStyle,
  },
  icon: {
    width: 30,
    height: 30,
  },
  shimmerContainer: theme => ({
    height: 200,
    width: '100%',
    borderRadius: 6,
    backgroundColor: theme.colors.cardBackgroundColor,
  }),
  errorCardStyle: {
    height: 200,
  },
});
